<script>
    import NauiButton from "./NauiButton.svelte";
    import {createEventDispatcher} from "svelte";

    const dispatch = createEventDispatcher();
    let input;
    let file;

    function manageFile(evt) {
        file = null;
        if (evt.target.files?.length > 0) {
            file = evt.target.files[0];
        }
        dispatch('file', file);
    }
</script>
<div>
    <div class="box-l sx-i">
        {#if file}
            <div style="border: 1px solid #ccc; border-radius: 25px; padding: .5rem 1rem;">
                {file?.name}
            </div>
        {/if}
        <NauiButton icon="arrow-to-top"
                    color="accent"
                    on:click={()=>input.click()}/>
    </div>


    <input type="file"
           bind:this={input}
           on:change={manageFile}
           style="display: none">
</div>